type OwnArgs = {
  hasEverLoaded: boolean;
  initialPreferredAcquisitionName?: string;
  isTradeInApplied: boolean;
  selectedTradeId: string | undefined;
  tradeCount: number;
};

/**
 * Pure core of useGetAcquisitionNameForApiRequest, shared by the client pricing hooks (VDP/SRP/Home
 * via the hook) and the server pricing seed (getVehiclePricing). The `!hasEverLoaded` branch only
 * fires client-side; the server passes hasEverLoaded=true since its trades seed is always resolved.
 */
export default function resolvePreferredAcquisitionName({
  hasEverLoaded,
  initialPreferredAcquisitionName,
  isTradeInApplied,
  selectedTradeId,
  tradeCount
}: OwnArgs): string {
  if (!isTradeInApplied) return '';

  if (!hasEverLoaded) return initialPreferredAcquisitionName ?? '';

  return tradeCount <= 1 ? '' : selectedTradeId ?? '';
}
